import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalizeString' })
export class CapitalizeStringPipe implements PipeTransform {
  transform(value: any, position: number): string {
    let result = value.charAt(0).toLocaleUpperCase() + value.slice(0 + 1);
    return result;
  }
}
